import { useFetchCloudfrontSignedCookies } from '@/utils/cloudfront';
import { useEffect, useState } from 'react';

export const useFetchCookies = () => {
  const [cookiesFetched, setCookiesFetched] = useState(false);
  const [cloudFrontCookiesFetched, setCloudFrontCookiesFetched] = useState(false);

  const { setCookies: fetchCloudFrontCookies } = useFetchCloudfrontSignedCookies();

  useEffect(() => {
    fetchCloudFrontCookies()
      .then(() => {
        setCookiesFetched(true);
        setCloudFrontCookiesFetched(true);
        setCookiesFetched(true);
      })
      .catch((error) => {
        console.error('fetchCloudFrontCookies ->', error);
      });
  }, [fetchCloudFrontCookies]);

  return cookiesFetched && cloudFrontCookiesFetched;
};
